import React, { FC } from 'react';

type Props = {
  title: string;
};

export const FooterHeading: FC<Props> = ({ title }) => (
  <h4 className="mr-2 w-full py-1 font-bold">{title}</h4>
);
